import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import EditMark from '../components/admin-view/components/itemsDetails/markerDetailContainer'
import { black, white } from '../getLPTheme';
import MenuBack from '../components/admin-view/menuBack'
import MapLocate from '../components/admin-view/components/itemsDetails/mapMarker/mapInitMarkerContainer'
import { Grid } from '@mui/material';
import Copyright from '../auxiliares/Copyright'


export default function Paperbase() {
  return (
    <Box
      sx={{
        bgcolor: black[1000],
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ bgcolor: black[1000] }}>
        <MenuBack />
      </Box>

      <Box
        sx={{
          bgcolor: black[1000],
          flexGrow: 1,                          
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 2, sm: 3, md: 6 },          
        }}
      >
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 4 }}
          alignItems="center"
          justifyContent="center"
          sx={{ width: '100%', maxWidth: 1400, px: { xs: 2, sm: 3 } }}
        >
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {/* el form se adapta solo (ver sección 2) */}
              <EditMark />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                // tamaño del mapa responsive
                '& > *': {
                  width: { xs: '100%', sm: 500, md: 560 },
                  height: { xs: 300, sm: 360, md: 420 },
                },
              }}
            >
              <MapLocate />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          bgcolor: black[1000],
          py: { xs: 2, md: 3 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Copyright />
      </Box>
    </Box>
  );
}

